// extracted by mini-css-extract-plugin
export var btn = "refinBlock-module--btn--if8FJ";
export var description = "refinBlock-module--description--bUI3G";
export var grid = "refinBlock-module--grid--MkoCq";
export var image = "refinBlock-module--image--eRXEC";
export var img_0 = "refinBlock-module--img_0--+HTnd";
export var img_1 = "refinBlock-module--img_1--JCIKl";
export var img_2 = "refinBlock-module--img_2--R1IO1";
export var itemBlock = "refinBlock-module--itemBlock--ZAHQU";
export var onlyTable = "refinBlock-module--onlyTable--9dXB7";
export var onlyTableAndMob = "refinBlock-module--onlyTableAndMob--vmKRS";
export var section = "refinBlock-module--section--fr+vs";
export var title = "refinBlock-module--title--iPdQS";
export var titleBlock = "refinBlock-module--titleBlock--7A4Hi";